export default __webpack_public_path__ + "static/media/michael_wu.14d87c93.jpg";